var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.essay.status == 'DRAFT')?_c('EssayReply'):(_vm.essay.status == 'CORRECTING' || _vm.essay.status == 'CORRECTED')?_c('Correction'):_c('Loading')}
var staticRenderFns = []

export { render, staticRenderFns }